<template>
  <div class="shape-mismatch-popup" v-click-outside="() => $emit('close')">
    <div class="header">
      <img src="~@/assets/icons/icon-database.svg" class="mr-10" />
      {{ $t("common.database") }}:&nbsp;
      <span class="text-capitalize">
        <strong>{{ databaseShapeName }}</strong>
      </span>
    </div>
    <div class="content">{{ $t("checkdata.header.check_dimensions") }}</div>
    <div class="pt-20 flex-center-between">
      <a class="action action--blue flex-center" href="#" @click.prevent="$emit('apply') + $emit('close')">
        <img src="~@/assets/icons/icon-confirm.svg" />
        &nbsp;{{ $t("common.apply") }}
      </a>
      <a class="action action--grey flex-center" href="#" @click.prevent="$emit('ignore') + $emit('close')">
        <img src="~@/assets/icons/icon-ignore.svg" />
        &nbsp;{{ $t("common.ignore") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    databaseShapeName: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/variables";

.shape-mismatch-popup {
  border: 1px solid $color-grey;
  width: 240px;
  height: 180px;
  left: 140px;
  bottom: 0;
  z-index: 100;
  background: $color-white;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 6px 6px 6px 0;
  color: $color-black;
}

.header {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0 20px 0;
}

.content {
  padding: 0 25px 25px;
  border-bottom: 1px solid $color-grey;
}

.action {
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
  width: 50%;
  letter-spacing: 1.25px;
  font-size: 13px;
  text-decoration: none;

  &--blue {
    color: $color-primary !important;
  }
  &--grey {
    color: $color-medium-grey;
  }
}
</style>
